export const base_path = "/api/v2";

export const apiPaths = {
  base_path,
  login_path: base_path + "/auth/login",
  register_user_path: base_path + "/auth/register",
  logout_path: base_path + "/auth/logout",
  forgot_pass_path: base_path + "/auth/reset-password",
  change_pass_path: base_path + "/auth/change-password",
  users_path: base_path + "/users",
  users_unblock_path: base_path + "/users/unblock",
  users_block_path: base_path + "/users/block",
  users_enable_path: base_path + "/users/enable",
  users_resend_invitation: base_path + "/users/resend-invitation",
  password_policy: base_path + "/users/password-policy",
  dep_path: base_path + "/departments",
  role_path: base_path + "/user_roles",
  prodtype_path: base_path + "/product_types",
  import_path: base_path + "/import",
  ca_path: base_path + "/cleaning_agents",
  log_path: base_path + "/audit_logs",
  rpn_formula_path: base_path + "/rpn_formulas",
  rpn_cat_path: base_path + "/rpn_categories",
  var_path: base_path + "/variables",
  formula_path: base_path + "/formulas",
  report_generation_path: base_path + "/reports/generate_report",
  dashboard_path: base_path + "/dashboard",
  dashboard_mac_limit_tracker_path: base_path + "/dashboard/mac_limit_tracker",
  default_units_path: base_path + "/default_units",
  feedback_path: base_path + "/feedback",
  features_path: base_path + "/features",
  log_report_path: base_path + "/audit_logs/last_report",
  cleaning_limit_policies_path: base_path + "/cleaning_limit_policies",
  department_path: base_path + "/departments",
  selection_criteria_path: base_path + "/selection-criteria",
  risk_control_path: base_path + "/risk-goal",
  analytical_method_path: base_path + "/analytical-method",
  reset_password_policy_path: base_path + "/auth/reset-password-policy",
  allowed_domains: base_path + "/users/allowedDomains",
  activeDirectorySearch: `${base_path}/activeDirectory/search`,
  activeDirectorySettings: `${base_path}/activeDirectory/settings`,
  historicalStudy: `${base_path}/historical-study`
};
